import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Contact } from "../models/contact";
import { CreateUserRequest } from "../models/user";
import { DisputeCaseTypeCount } from "../models/dispute-resolution/dispute-base-models";
import { DataListTagGroup } from "../models/data-list";

@Injectable({
  providedIn: "root",
})
export class PublicDisputeResolutionService {
  private baseUrl = "api/public/dr";

  constructor(private http: HttpClient) { }

  getDisputeCaseTypesWithCounts() {
    return this.http.get<DisputeCaseTypeCount[]>(`${this.baseUrl}/dispute-case-types-with-counts`);
  }

  getTagGroups() {
    return this.http.get<DataListTagGroup[]>(`${this.baseUrl}/tag-groups`);
  }

  getSpedDirectorsByAu(administrativeUnitId: string) {
    return this.http.get<Contact[]>(
      `${this.baseUrl}/sped-directors-by-au/${administrativeUnitId}`
    );
  }

  createPublicUser(request: CreateUserRequest) {
    return this.http.post<any>(`${this.baseUrl}/create-public-user`, request);
  }

  checkUserExists(email: string) {
    return this.http.get<boolean>(`${this.baseUrl}/check-user-exists`, {
      params: { email },
    });
  }
}
